import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex, Box } from 'reflexbox'
import { Element } from 'react-scroll'
import { withRouter } from 'react-router-dom'

import SpecContainer from '../SpecSection/index'
import SupportTeamContainer from '../SupportTeamSection/index'
import ApproverActionBarContainer from '../ApproverActionBar/index'
import ApproverContainer from '../ApproverSection/index'
import CommentContainer from '../CommentSection/index'
import HistoryContainer from '../HistorySection/index'
import ScheduleContainer from '../ScheduleSection/index'
import styles from './styles.scss'
import {
  changeCurrentApproval,
} from 'containers/Approval/ApprovalPage/actions'
import {
  currentApprovalSelector,
} from 'containers/Approval/ApprovalPage/selectors'

const mapStateToProps = (state) => {
  return {
    currentApproval: currentApprovalSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeCurrentApproval: (id) => dispatch(changeCurrentApproval(id)),
  }
}

class MainPanel extends Component {
  componentDidMount() {
    const { match, changeCurrentApproval } = this.props
    changeCurrentApproval(match.params.id)
  }

  componentDidUpdate(prevProps) {
    const { match, changeCurrentApproval } = this.props
    if (prevProps.match.params.id !== match.params.id) {
      changeCurrentApproval(match.params.id)
    }
  }

  render() {
    let approverActionBar = null,
      approverSection = null,
      commentSection = null,
      specSection = null,
      historySection = null,
      supportTeamSection = null,
      scheduleSection = null
    
    const projectId = this.props.match.params.id

    if (this.props.currentApproval){
      approverActionBar = <ApproverActionBarContainer/>
      supportTeamSection = <SupportTeamContainer projectId={projectId} />
      commentSection = <CommentContainer/>
      historySection = <HistoryContainer/>
      approverSection = <ApproverContainer/>
      scheduleSection = <ScheduleContainer/>
      specSection = <SpecContainer/>
    }

    return (
      <Flex id='scrollContainer' column auto styleName='mainPanel'>
        <Element name='specContainer'>
          { specSection }
        </Element>
        <Element name='scheduleContainer'>
          { scheduleSection }
        </Element>
        <Element name='supportTeamContainer'>
          { supportTeamSection }
        </Element>
        <Element name='approvalContainer'>
          { approverSection }
        </Element>
        <Element name='commentContainer'>
          { commentSection }
        </Element>
        <Element name='historyContainer'>
          { historySection }
        </Element>
        <Box auto/>
				{ approverActionBar }
      </Flex>
    )
  }
}
const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withRouter,
  withConnect,
  withStyles
)
export default enhance(MainPanel)
